export default "__VITE_ASSET__Bq$7bBjo__"